<template>
	<div class="edit-user">
		<Breadcrumbs :items="items" />
		<v-container fluid>
			<UserForm :user="user" :specialities="specialities" :edit="true" />
		</v-container>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import UserForm from "@/components/settings/UserForm.vue";
import axios from "axios";

export default {
	name: "EditUser",
	components: {
		Breadcrumbs,
		UserForm
	},
	props: ["specialities"],
	data: () => ({
		user: {}
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Settings"),
					disabled: false,
					link: true,
					to: { name: "settings" }
				},
				{
					text: this.$gettext("Users"),
					disabled: false,
					link: true,
					to: { name: "settings", params: { tab: "users" } }
				},
				{
					name: true,
					text: this.user.name,
					disabled: true,
					link: true
				},
				{
					text: this.$gettext("Edit"),
					disabled: true,
					link: true
				}
			];
		}
	},
	created() {
		axios
			.get("/user/" + this.$route.params.uid + "/edit")
			.then(response => {
				console.log(response.data);
				if (response.status === 200) {
					this.user = response.data.user;
				}
			})
			.catch(error => console.log(error));
	}
};
</script>